export function getInputValue(id: string): string {
    const el = document.getElementById(id) as HTMLInputElement | null;
    return el ? el.value.trim() : '';
}

export function getCheckboxValue(id: string): boolean {
    const el = document.getElementById(id) as HTMLInputElement | null;
    return el ? el.checked : false;
}

export function getCsrfToken(): string {
    const tokenInput = document.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]');
    return tokenInput ? tokenInput.value : '';
}

export function bindInputName(parent: HTMLElement, selector: string, name: string): void {
    const input = parent.querySelector<HTMLInputElement | HTMLSelectElement>(selector);
    if (input) input.name = name;
}

/**
 * Reads event-scoped values rendered onto the checkout form by the
 * server (data-event-date / data-eligibility-rating-type attributes on
 * #CheckoutForm). Used by the USCF search so results reflect the rating
 * that actually applies to this event, not always "today."
 */
export function getEventContext(): { eventDate: string | null; eligibilityRatingType: string | null } {
    const form = document.getElementById('CheckoutForm');
    return {
        eventDate: form?.getAttribute('data-event-date') || null,
        eligibilityRatingType: form?.getAttribute('data-eligibility-rating-type') || null
    };
}